import { render, staticRenderFns } from "./CreateBoxLimit.vue?vue&type=template&id=477615a6&scoped=true&"
import script from "./CreateBoxLimit.vue?vue&type=script&lang=js&"
export * from "./CreateBoxLimit.vue?vue&type=script&lang=js&"
import style0 from "./CreateBoxLimit.vue?vue&type=style&index=0&id=477615a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477615a6",
  null
  
)

export default component.exports